import { createApp } from 'vue';
import App from './App.vue';
import '@/assets/css/value.css';
import '@/assets/css/common.css';
import '@/assets/css/comp.css';
import 'vant/es/toast/style';
import '@/assets/iconfont/iconfont.css';
import router from './route/index';
import toast from '@/utils/toast';
import {Config} from '@/api/plcore';
import EventHandler from '@/api/event';
import i18n from './language.js'
import store from './store/index.js'
/**
 * 由app调用,设置目标网关信息 
 * @param {网关ip} ip 
 * @param {网关端口} port 
 */
window.androidCall_SetIp = (ip,port)=>{
    Config.ip = ip;
    Config.port = port;
}
/**
 * app调用,当设备属性变化时通知web
 * @param {属性值} propertiesJson 
 */
window.androidCall_onPropertiesChangeEvent = (propertiesJson) => {
    EventHandler.propertiesEventHandler(propertiesJson);
}

import { Form, Field, CellGroup,Button } from 'vant';

// toast = new Toast();
// toast.debug = true;

const app = createApp(App);
app.use(router)
app.use(i18n)
app.use(store)
app.use(toast)
app.use(Field);
app.use(CellGroup);
app.use(Button);
app.use(Form).mount('#app')
